var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.9375 42.5C84.9375 53.7551 80.4664 64.5493 72.5078 72.5078C64.5493 80.4664 53.7551 84.9375 42.5 84.9375C31.2449 84.9375 20.4507 80.4664 12.4922 72.5078C4.53358 64.5493 0.0625 53.7551 0.0625 42.5C0.0625 31.2449 4.53358 20.4507 12.4922 12.4922C20.4507 4.53358 31.2449 0.0625 42.5 0.0625C53.7551 0.0625 64.5493 4.53358 72.5078 12.4922C80.4664 20.4507 84.9375 31.2449 84.9375 42.5ZM54.625 30.375C54.625 33.5908 53.3475 36.6748 51.0737 38.9487C48.7998 41.2225 45.7158 42.5 42.5 42.5C39.2842 42.5 36.2002 41.2225 33.9263 38.9487C31.6525 36.6748 30.375 33.5908 30.375 30.375C30.375 27.1593 31.6525 24.0752 33.9263 21.8013C36.2002 19.5275 39.2842 18.25 42.5 18.25C45.7158 18.25 48.7998 19.5275 51.0737 21.8013C53.3475 24.0752 54.625 27.1593 54.625 30.375ZM42.5 48.5625C37.2522 48.5605 32.0938 49.921 27.5296 52.5108C22.9653 55.1006 19.1516 58.8309 16.4616 63.3368C19.5833 67.2438 23.5453 70.3971 28.0532 72.5623C32.5611 74.7276 37.499 75.8492 42.5 75.8438C47.4999 75.8483 52.4366 74.7262 56.9434 72.561C61.4502 70.3958 65.4113 67.243 68.5324 63.3368C65.8429 58.8318 62.0301 55.102 57.467 52.5123C52.9039 49.9226 47.7468 48.5616 42.5 48.5625Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImg);
export default __webpack_public_path__ + "static/media/defaultImg.26340de957f15093f3dab6f3d086ec23.svg";
export { ForwardRef as ReactComponent };